import { gql } from "@apollo/client";
import moment from "moment";

export const GET_INFORMACION_GENERAL = gql`
query informacionGeneralVisita($idEvaluacion: Int!,$idProfesional: Int!, $idFrecuencia: Int!, $idVisita: Int) {
    informacionGeneralVisita(idEvaluacion: $idEvaluacion , idProfesional: $idProfesional, idFrecuencia: $idFrecuencia, idVisita: $idVisita) {
    success
    error
    valorEsperado {
      idPaciente
      paciente
      fechaNacimiento
      edad
      sexo
      direccion {
        domicilio
        provincia
        cP
        localidad
        pais
      }
      observacionAsistencial
      telefono
      telefonFamiliar
      programa
      planAsistencial
      periodoSuspension
      idCliente
      cliente
      idTipoModulo
      frecuencia
      visitasPendientes
      visitasRealizadas
      directivasAnticipadas
      alergias
    }
  }
}`;

export const parseInformacionGeneral = (data) => {
  const { direccion, fechaNacimiento, ...rest } = data.valorEsperado || {};

  return {
    ...rest,
    direccion: `${direccion?.domicilio || ''}, ${direccion?.provincia || ''}, ${direccion?.cP || ''}, ${direccion?.localidad || ''}, ${direccion?.pais || ''}`,
    fechaNacimiento: fechaNacimiento ? moment(fechaNacimiento).format('DD/MM/YYYY') : ''
  };
};